import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import {
  tagManagerPurchase,
  tagManagerInit,
  mayPushTransaction,
  setTransactionAsPushed,
  gtag,
} from "./util";
import { AppContext } from "../../context";
import Cookies from "universal-cookie";

const TagManager = ({ posId, receipt }) => {
  const { state } = useContext(AppContext);
  const { config } = state;
  const [dataLayer, setDataLayer] = useState(window.dataLayer);
  const [trackingAdded, setTrackingAdded] = useState(false);
  const [reload, setReload] = useState(0);
  const cookies = useMemo(() => new Cookies(), []);

  const sendUpdateConsent = useCallback((consent) => {
    gtag("consent", "update", consent);
  }, []);

  useEffect(() => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const consent = params.get("consent");
    if (consent) {
      cookies.set("shop-consent", consent);
      params.delete("consent");
      url.search = params.toString();
      window.history.replaceState({}, document?.title, url.toString());
    }
  }, []);

  useEffect(() => {
    const consent = cookies.get("shop-consent");
    if (consent && config?.useTagManager) {
      tagManagerInit(posId, config);
      sendUpdateConsent(consent);
    }
  }, [config, posId, cookies]);

  useEffect(() => {
    if (!dataLayer && reload < 6) {
      setTimeout(() => {
        if (!window.dataLayer) {
          // console.log(`No window.dataLayer, try ${reload + 1}`);
          return setReload(reload + 1);
        }
        setDataLayer(window.dataLayer);
      }, 1000);
    } else {
      if (!dataLayer) {
        return console.log("No dataLayer");
      }

      if (!trackingAdded && receipt && mayPushTransaction(receipt)) {
        console.log(receipt, dataLayer, config?.useGA4TagManager);
        tagManagerPurchase(receipt, dataLayer, config?.useGA4TagManager);
        setTrackingAdded(true);
        setTransactionAsPushed(receipt);
      }
    }
  }, [
    trackingAdded,
    setTrackingAdded,
    dataLayer,
    setDataLayer,
    receipt,
    reload,
    setReload,
  ]);

  return null;
};

export default TagManager;
